import type { PlanArea, StudyPlanConfig, SubjectMeta } from './engine'

export const STUDY_PLAN_EXAM_DATE = '2027-06-20'

export const AREAS: Record<string, PlanArea> = {
  sayisal: {
    label: 'Sayısal',
    cycle: ['Matematik', 'Fen', 'Türkçe', 'Geometri', 'Matematik', 'Fizik', 'Kimya', 'Biyoloji'],
  },
  ea: {
    label: 'Eşit Ağırlık',
    cycle: ['Matematik', 'Türkçe', 'Geometri', 'Sosyal', 'Matematik', 'Edebiyat', 'Tarih', 'Coğrafya'],
  },
  sozel: {
    label: 'Sözel',
    cycle: ['Türkçe', 'Edebiyat', 'Tarih', 'Coğrafya', 'Matematik', 'Felsefe', 'Sosyal', 'Türkçe'],
  },
  dil: {
    label: 'Dil',
    cycle: ['İngilizce', 'Türkçe', 'Kelime', 'İngilizce', 'Grammatik', 'Sosyal', 'Kelime', 'Türkçe'],
  },
}

export const STUDY_PLAN_GOALS: readonly string[] = [
  'Tıp',
  'Dişçilik',
  'Eczacılık',
  'Hemşirelik',
  'Bilgisayar Müh.',
  'Uçak Müh.',
  'Simülasyon Müh.',
  'Hukuk',
  'Psikoloji',
  'Mimarlık',
]

export const GOAL_BOOST: Record<string, string[]> = {
  'Tıp': ['Biyoloji', 'Kimya'],
  'Dişçilik': ['Biyoloji'],
  'Eczacılık': ['Biyoloji', 'Kimya'],
  'Hemşirelik': ['Biyoloji'],
  'Bilgisayar Müh.': ['Matematik', 'Geometri'],
  'Uçak Müh.': ['Matematik', 'Fizik'],
  'Simülasyon Müh.': ['Matematik', 'Fizik'],
  'Hukuk': ['Türkçe', 'Tarih'],
  'Psikoloji': ['Biyoloji', 'Türkçe'],
  'Mimarlık': ['Geometri', 'Matematik'],
}

export const HOURS_BY_GRADE: Record<'lise' | 'mezun', string[]> = {
  lise: ['1 saat', '2 saat', '3 saat', '4+ saat'],
  mezun: ['6 saat', '8 saat', '10 saat'],
}

export const SUBJECTS: Record<string, SubjectMeta> = {
  'Matematik': { icon: '📐', cls: 'mat' },
  'Geometri': { icon: '📏', cls: 'geo' },
  'Fizik': { icon: '🧲', cls: 'fiz' },
  'Kimya': { icon: '⚗️', cls: 'kim' },
  'Biyoloji': { icon: '🧬', cls: 'biy' },
  'Türkçe': { icon: '📖', cls: 'tur' },
  'Edebiyat': { icon: '📚', cls: 'ede' },
  'Tarih': { icon: '🏛️', cls: 'sos' },
  'Coğrafya': { icon: '🗺️', cls: 'cog' },
  'Felsefe': { icon: '🤔', cls: 'fel' },
  'Sosyal': { icon: '🌍', cls: 'sos' },
  'İngilizce': { icon: '🔤', cls: 'dil' },
  'Kelime': { icon: '🔤', cls: 'dil' },
  'Grammatik': { icon: '✍️', cls: 'dil' },
}

export const SUBJECT_FALLBACK: SubjectMeta = { icon: '📘', cls: 'gen' }

export const DEFAULT_STUDY_PLAN_CONFIG: StudyPlanConfig = {
  examDate: STUDY_PLAN_EXAM_DATE,
  areas: AREAS,
  goalBoost: GOAL_BOOST,
}
